import React from "react";
import { get, isEmpty } from "lodash";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@material-ui/core";
import { displayData } from "../../../utils/ContentFinderUtils";

const NotesSection = ({ notes }) => {
  const notesList = Array.isArray(notes) ? notes : notes ? [notes] : [];
  const sortedNotes = [...notesList].sort(
    (a, b) =>
      new Date(get(b, "createdDatetime")).getTime() -
      new Date(get(a, "createdDatetime")).getTime()
  );

  return (
    <section className="drawer-section">
      <h2 className="drawer-section-title">Notes</h2>
      <TableContainer
        component={Paper}
        className="content-finder-table-container drawer-table-container notes-table-container"
      >
        <Table className="content-finder-table content-finder-table--no-scroll notes-table">
          <TableBody className="content-finder-table-body">
            {isEmpty(sortedNotes) ? (
              <TableRow className="tableRow content-finder-body-row">
                <TableCell className="content-finder-table-cell drawer-empty-cell">
                  No Notes Found
                </TableCell>
              </TableRow>
            ) : (
              sortedNotes.map((note, i) => (
                <React.Fragment key={i}>
                  <TableRow className="tableRow content-finder-body-row">
                    <TableCell className="content-finder-table-cell">
                      {displayData(get(note, "createdDatetime"), {
                        dateFormat: "YYYY-MM-DD hh:mm",
                      })}
                    </TableCell>
                    <TableCell className="content-finder-table-cell">
                      {displayData(get(note, "createdUserID"))}
                    </TableCell>
                  </TableRow>
                  <TableRow className="tableRow content-finder-body-row">
                    <TableCell
                      className="content-finder-table-cell"
                      colSpan={2}
                    >
                      {displayData(get(note, "description"))}
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </section>
  );
};

export default NotesSection;
